import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { OtherType } from "../@type/otherType";

class OtherTypeService {
  get = async (type: string): Promise<AxiosResponse> => {
    try {
      const response = await getAsync(`other-services/type/${type}`);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  getById = async (id: number): Promise<AxiosResponse> => {
    return await getAsync(`other-services/${id}`);
  };
  post = async (productData: any): Promise<AxiosResponse> => {
    return await postAsync("other-services", productData);
  };
  delete = async (id: number): Promise<AxiosResponse> => {
    return await deleteAsync(`other-services/${id}`);
  };
  updateById = async (id: number, data: OtherType): Promise<AxiosResponse> => {
    return await putAsync(`other-services/${id}`, data);
  };
}

const otherTypeService = new OtherTypeService();

export default otherTypeService;
